import React from 'react';
import { TextField, MenuItem, TextFieldProps } from '@mui/material';

export type SelectProps = TextFieldProps & {
  options: { value: string; label: string }[];
};

export const Select = React.forwardRef<HTMLInputElement, SelectProps>(
  ({ className, label, options, ...props }, ref) => {
    return (
      <TextField
        select
        inputRef={ref}
        label={label}
        fullWidth
        variant="outlined"
        size="small"
        className={className}
        {...props}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    );
  }
);
Select.displayName = 'Select';
